import { render } from "./Order.vue?vue&type=template&id=77d5e4be&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=77d5e4be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77d5e4be"

export default script